import { render, staticRenderFns } from "./faceVerifying.vue?vue&type=template&id=29c79b74&scoped=true"
import script from "./faceVerifying.vue?vue&type=script&lang=js"
export * from "./faceVerifying.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c79b74",
  null
  
)

export default component.exports